import { NgModule } from '@angular/core';

@NgModule({
  exports: [
  ],
  declarations: [
  ],
  providers: [
  ]
})
export class CieOrderProcessModule {
}
